export default function RightChevron() {
  return (
    <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.559346 1.16616L5.44056 5.47672C5.7167 5.72058 5.74266 6.14189 5.49855 6.41774C5.48123 6.43732 5.46277 6.45586 5.44328 6.47327L0.556627 10.8363C0.281819 11.0816 0.258154 11.5031 0.503768 11.7776C0.749382 12.0521 1.17127 12.0758 1.44607 11.8304L6.33272 7.4674C6.39122 7.41517 6.44659 7.35956 6.49855 7.30084C7.23089 6.47327 7.15299 5.20933 6.32456 4.47776L1.44335 0.167193C1.16721 -0.076666 0.745463 -0.0507274 0.501351 0.225129C0.257239 0.500984 0.283204 0.922297 0.559346 1.16616Z"
        fill="black"
        fillOpacity="0.55"
      />
    </svg>
  );
}
